<a class="banner-content text-grey-90 is-flex gap-16 bg-grey-0 radius-12 is-align-center" [attr.href]="bannerLink">
  <div class="is-flex-shrink-0 is-flex is-align-center">
    <img class="" srcset="/assets/banner/banner.png, /assets/banner/banner@2x.png 2x, /assets/banner/banner@3x.png 3x" alt="">
  </div>
  <div class="text-content is-flex is-column is-justify-space-between is-flex-grow-1">
    <div class="is-flex is-justify-space-between">
      <app-text class="is-family-semiBold text-18" [text]="'app.__SPECIAL_LAUNCH_OFFER' | AsyncLang | async"/>
      <app-icon class="text-blue text-32" name="small-arrow-right"/>
    </div>
    <div class="is-flex gap-8 is-align-center">
      <app-text class="is-family-medium text-16 text-grey-70" [text]="'app.__DISCOVER_WEATHER_ORIGINAL' | AsyncLang | async"/>
    </div>
  </div>
</a>